// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"c8c3e32a","165":"168eb36f","378":"3de69bf1","473":"9d634bbf","947":"6d3f6a29"}[chunkId] + ".chunk.css";
};